import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import templateHtml from 'pages/settings/templates/DataStorageConsentModal.html';

export default Backbone.View.extend({
    template: _.template(templateHtml),

    events: {
        'click .btn-primary': 'onPrimaryClick'
    },

    initialize: function(args) {
        this.onAccept = args.onAccept;
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer
            })
        );
        return this;
    },

    onPrimaryClick: function(e) {
        e.preventDefault();
        if (this.onAccept) {
            this.onAccept();
        }
    }
});
